import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getLogo, getShortName, getSocialMedia } from '../../data/companyDetails';

const Navbar = () => {
  const location = useLocation();
  const logo = getLogo();
  const shortName = getShortName();
  const socialMedia = getSocialMedia();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  // Helper function to check if a path is active
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') {
      return true;
    }
    return location.pathname === path;
  };

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when link is clicked
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Close menu when screen size changes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div 
      ref={navbarRef}
      className="container-fluid sticky-top px-0" 
      style={{
        background: 'rgba(255, 255, 255, 0.95)', 
        backdropFilter: 'blur(15px)',
        WebkitBackdropFilter: 'blur(15px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}
    >
      <nav className="navbar navbar-expand-lg navbar-light px-4 py-3">
        <Link to="/" className="navbar-brand d-flex align-items-center" onClick={closeMenu}>
          <img src={logo.src} alt={logo.alt} height={45} width={45} className="me-3" />
          <h1 className="h4 mb-0 text-primary fw-bold">{shortName}</h1>
        </Link>
        
        <button 
          className="navbar-toggler border-0 shadow-none d-lg-none" 
          type="button" 
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className={`navbar-toggler-icon ${isMenuOpen ? 'd-none' : ''}`}></span>
          {isMenuOpen && <i className="fas fa-times fa-lg text-primary"></i>}
        </button>
        
        <div className={`navbar-collapse collapse${isMenuOpen ? ' show' : ''}`} id="navbarNav">
          <div className="navbar-nav mx-auto py-2">
            <Link 
              to="/about" 
              className={`nav-link px-3 py-2 mx-1 rounded-pill transition-all ${
                isActive('/about') 
                ? 'bg-primary text-white fw-bold shadow-sm' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={closeMenu}
            >
              About
            </Link>
            <Link 
              to="/privacy" 
              className={`nav-link px-3 py-2 mx-1 rounded-pill transition-all ${
                isActive('/privacy') 
                ? 'bg-primary text-white fw-bold shadow-sm' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={closeMenu}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className={`nav-link px-3 py-2 mx-1 rounded-pill transition-all ${
                isActive('/terms') 
                ? 'bg-primary text-white fw-bold shadow-sm' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={closeMenu}
            >
              Terms & Conditions
            </Link>
            <Link 
              to="/refund" 
              className={`nav-link px-3 py-2 mx-1 rounded-pill transition-all ${
                isActive('/refund') 
                ? 'bg-primary text-white fw-bold shadow-sm' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={closeMenu}
            >
              Refund Policy
            </Link>
            <Link 
              to="/contact" 
              className={`nav-link px-3 py-2 mx-1 rounded-pill transition-all ${
                isActive('/contact') 
                ? 'bg-primary text-white fw-bold shadow-sm' 
                : 'text-dark hover-bg-light'
              }`}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </div>
          
          <div className="d-flex align-items-center mt-3 mt-lg-0">
            <Link 
              to="/user" 
              className="btn btn-primary rounded-pill py-2 px-4 fw-bold shadow-sm d-flex align-items-center"
              onClick={closeMenu}
            >
              <i className="fas fa-download me-2"></i>
              Get Started
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
